"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * BackEnd FrontEndで利用するtext...
 *
 */
exports.default = Object.freeze({
    ja: {
        dictionary: {
            todo_fuken: [
                { text: '北海道', value: '北海道' },
                { text: '青森県', value: '青森県' },
                { text: '岩手県', value: '岩手県' },
                { text: '宮城県', value: '宮城県' },
                { text: '秋田県', value: '秋田県' },
                { text: '山形県', value: '山形県' },
                { text: '福島県', value: '福島県' },
                { text: '茨城県', value: '茨城県' },
                { text: '栃木県', value: '栃木県' },
                { text: '群馬県', value: '群馬県' },
                { text: '埼玉県', value: '埼玉県' },
                { text: '千葉県', value: '千葉県' },
                { text: '東京都', value: '東京都' },
                { text: '神奈川県', value: '神奈川県' },
                { text: '新潟県', value: '新潟県' },
                { text: '富山県', value: '富山県' },
                { text: '石川県', value: '石川県' },
                { text: '福井県', value: '福井県' },
                { text: '山梨県', value: '山梨県' },
                { text: '長野県', value: '長野県' },
                { text: '岐阜県', value: '岐阜県' },
                { text: '静岡県', value: '静岡県' },
                { text: '愛知県', value: '愛知県' },
                { text: '三重県', value: '三重県' },
                { text: '滋賀県', value: '滋賀県' },
                { text: '京都府', value: '京都府' },
                { text: '大阪府', value: '大阪府' },
                { text: '兵庫県', value: '兵庫県' },
                { text: '奈良県', value: '奈良県' },
                { text: '和歌山県', value: '和歌山県' },
                { text: '鳥取県', value: '鳥取県' },
                { text: '島根県', value: '島根県' },
                { text: '岡山県', value: '岡山県' },
                { text: '広島県', value: '広島県' },
                { text: '山口県', value: '山口県' },
                { text: '徳島県', value: '徳島県' },
                { text: '香川県', value: '香川県' },
                { text: '愛媛県', value: '愛媛県' },
                { text: '高知県', value: '高知県' },
                { text: '福岡県', value: '福岡県' },
                { text: '佐賀県', value: '佐賀県' },
                { text: '長崎県', value: '長崎県' },
                { text: '熊本県', value: '熊本県' },
                { text: '大分県', value: '大分県' },
                { text: '宮崎県', value: '宮崎県' },
                { text: '鹿児島県', value: '鹿児島県' },
                { text: '沖縄県', value: '沖縄県' }
            ],
            button_caption: {
                ok: 'OK',
                cancel: 'キャンセル'
            },
            select: {
                default_text: '選択'
            }
        },
        view: {
            login: {
                button_caption: 'ログイン',
                label: {
                    user_name: 'メールアドレス',
                    password: 'パスワード'
                }
            },
            link: {
                privacy: {
                    href: 'https://rehab.cloud/privacy-policy/',
                    text: 'プライバシーポリシー'
                },
                rehab_cloud_policy: {
                    href: 'https://rehab.cloud/terms/',
                    text: 'Rehab Cloud規約'
                },
                rehab_cloud_tablet_policy: {
                    href: 'https://rehab.cloud/terms-tablet/',
                    text: 'Rehab Cloudタブレット規約'
                },
                policy: {
                    href: 'https://rehab.cloud/terms/',
                    text: '利用規約'
                },
                service_usage_compliance_document: {
                    href: 'https://cdn.rehab.cloud/service_specification_conformance_disclosure/202404_ver1.pdf',
                    text: 'サービス仕様適合書'
                }
            },
            footer: [
                {
                    title: "運営会社",
                    link: "https://rehabforjapan.com/"
                }, {
                    title: "プライバシーポリシー",
                    link: "https://rehab.cloud/privacy-policy/"
                },
                {
                    link: 'https://cdn.rehab.cloud/service_specification_conformance_disclosure/202404_ver1.pdf',
                    title: 'サービス仕様適合書'
                },
                {
                    title: "お問い合わせ",
                    link: "https://rehaplan.jp/service/feedback"
                }
            ],
            components: {
                error_panel: {
                    validate_fail_message: '入力内容に誤りがございます。赤字箇所を修正して下さい。'
                }
            },
            contract_form: {
                hint: {
                    email: ''
                },
                placeholder: {
                    email: 'mail@example.com'
                },
                confirm_email: {
                    messages: {
                        top: '確認メールを送信しました',
                        top_detail: {
                            target_email: '{email}に申込フォームのURLを送信しました。ご確認ください。',
                            email_setting: 'メール受信制限をされている方は、 noreply@rehaplan.jp からのメール受信を許可してください。'
                        },
                        error: {
                            email: '有効なメールアドレスを入力してください'
                        }
                    }
                },
                confirm_identification_email: {
                    messages: {
                        top: '確認メールを送信しました',
                        top_detail: {
                            target_email: '{email}に本人／法人確認データ送信完了の旨を送信しました。ご確認ください。',
                            email_setting: 'メール受信制限をされている方は、 noreply@rehaplan.jp からのメール受信を許可してください。'
                        },
                        error: {
                            email: '有効なメールアドレスを入力してください'
                        }
                    }
                },
                complete_submit_comparing_data: {
                    messages: {
                        complete_alert_top: 'お客様のご本人／法人確認データ送信は完了しております。',
                        complete_alert_detail: {
                            target_email: '現在、お客様のご本人／法人確認の審査中、若しくは審査が完了しております。',
                            after_process: '審査が完了しております場合、審査結果をお客様のメールアドレス宛にお送りしております。',
                            after_retry_process: '審査が完了するまでもう暫くお待ちください。',
                            email_setting: 'メール受信制限をされている方は、 noreply@rehaplan.jp からのメール受信を許可してください。'
                        }
                    }
                },
                complete: {
                    messages: {
                        complete_alert_top: '申込が完了しました',
                        complete_alert_detail: {
                            target_email: '{email}に申込いただいた内容をお送りしております。',
                            after_process: '申込内容確認後、2~3営業日以内に【契約内容確定】のご連絡をさせていただきます。',
                            email_setting: 'メール受信制限をされている方は、 noreply@rehaplan.jp からのメール受信を許可してください。'
                        }
                    }
                },
                update: {
                    messages: {
                        error: {
                            required: 'は必須の項目です',
                            documentId: '',
                            officeInfoRequestEmail: '',
                            officeInfoRequestPersonLastName: '',
                            officeInfoRequestPersonFirstName: '',
                            officeInfoRequestPersonKanaLastName: '',
                            officeInfoRequestPersonKanaFirstName: '',
                            officeInfoOfficeNo: '10桁の英数字で入力してください',
                            officeInfoCompanyName: '',
                            officeInfoCompanyNameKana: '',
                            officeInfoOfficeName: '',
                            officeInfoOfficeNameKana: '',
                            officeInfoCompanyNo: '13桁の法人番号を入力してください',
                            officeInfoZip1: '',
                            officeInfoZip2: '',
                            officeInfoAddress1: '',
                            officeInfoAddress2: '',
                            officeInfoAddress3: '',
                            officeInfoTel: '有効な電話番号を入力してください',
                            officeInfoTantosyaLastName: '',
                            officeInfoTantosyaFirstName: '',
                            officeInfoTantosyaKanaLastName: '',
                            officeInfoTantosyaKanaFirstName: '',
                            officeInfoTantosyaMail: '有効なメールアドレスを入力してください',
                            applyInfoApplyService: 'いずれかを選択してください',
                            applyInfoKinoKunrenPeriod: '',
                            applyInfoApplyCapacity: '',
                            applyInfoOralCarePeriod: '',
                            applyInfoKinoKunrenStartDate: '',
                            applyInfoOralCareSstartDate: '',
                            applyInfoInputNumber: '',
                            requestInfoCompanyName: '',
                            requestInfoCompanyNameKana: '',
                            requestInfoZip1: '',
                            requestInfoZip2: '',
                            requestInfoAddress1: '',
                            requestInfoAddress2: '',
                            requestInfoAddress3: '',
                            requestInfoTel: '',
                            requestInfoRequestPersonLastName: '',
                            requestInfoRequestPersonFirstName: '',
                            requestInfoRequestPersonKanaLastName: '',
                            requestInfoRequestPersonKanaFirstName: '',
                            requestInfoRequestEmail: '',
                            requestInfoHowToRequest: '',
                            aboutInputService: '内容を確認し、「確認しました」にチェックを入れてください。',
                            aboutRequest: '内容を確認し、「確認しました」にチェックを入れてください。',
                        },
                        confirm_alert: 'まだお申込は完了していません。入力内容を確認し、「上記に同意して申込む」ボタンをクリックしてください。',
                        standard_plan_message: "Rehab Cloud Entry / Medium / Standard / Proをお申し込みのお客様は、国税庁に登録・発行された法人番号・法人名・法人住所と一致させる必要があります。 <br> 法人番号については登記簿謄本の12桁の番号ではなく13桁の番号になりますのでご注意ください。法人番号・法人名・法人住所の検索は<a class='caption' href='https://www.houjin-bangou.nta.go.jp/' target='_blank'>こちら</a>",
                        company_confirm_message: "法人番号については登記簿謄本の12桁の番号ではなく13桁の番号になりますのでご注意ください。法人番号・法人名・法人住所の検索は<a class='caption' href='https://www.houjin-bangou.nta.go.jp/' target='_blank'>こちら</a>",
                        select_service_message: '「リハプラン 機能訓練」「リハプラン 口腔機能」の中から、導入を希望するサービスをクリックし、必要項目を入力してください。<br>導入を希望しないサービスのチェックを外してください。なお、あらかじめ「リハプラン 機能訓練」にチェックが入っています。',
                        input_agency_message: '申込プランに関わらず、入力代行が必要な場合は、入力代行人数を入力してください',
                        request_info_message: '請求書の宛先となる法人の情報、支払い方法を入力してください。<br>事業所情報と同じ場合は、「事業所情報と同じ」にチェックを入れてください。',
                        shipping_address_info_message: '配送先担当者名はご本人様確認担当者と同一である必要があります。',
                        shipping_address_info_cautionary_notice_about_fee: '※配送先住所に間違いがあった場合、<br>差額の転送料金が発生する可能性がございます。<br>その場合の転送料金はお客様負担（着払い）となりますので、<br>ご了承ください。',
                        consent: {
                            about_moneyforward_request: [
                                {
                                    block: {
                                        top: '当サービスではマネーフォワードケッサイ株式会社が、請求業務の受託及び代金債権の収受権限の付与を受け、又は、販売元から当該債権の債権譲渡を受けて、請求書の発行や代金の回収、管理を行っております。\n' +
                                            '審査の結果、別のお支払方法をご提案する可能性がございます。予めご了承ください。',
                                        details: [
                                            '請求書の発行元およびご入金先口座名義は、マネーフォワードケッサイ株式会社となります。',
                                            'お間違えのないようご注意ください。',
                                            'その他、よくあるご質問やお問い合わせにつきましては下記をご参照ください。',
                                            'https://inquiry.mfkessai.co.jp/'
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '「支払い方法」にて「口座振替」を選択された場合は、別途郵送する申請書類に必要事項をご記入の上ご提出ください。手続き完了まで時間を要しますので、予めご了承ください。また、手続き完了までの期間は銀行振込でのお支払いとなります。',
                                        details: []
                                    }
                                },
                                {
                                    block: {
                                        top: '振込手数料は貴社にてご負担いただけますようお願い申し上げます。',
                                        details: []
                                    }
                                },
                                {
                                    block: {
                                        top: '領収証の発行を承っておりません。銀行での振込票(ご利用明細)　または通帳の記載をもって領収書の発行に代えさせていただきます。',
                                        details: []
                                    }
                                },
                                {
                                    block: {
                                        top: 'サービス提供期間中に解約した場合、利用料金その他料金の払い戻しは承りません。',
                                        details: []
                                    }
                                },
                                {
                                    block: {
                                        top: 'サービスは、本導入申込が受諾された時点より契約開始となり、サービス利用開始時点より利用開始となります。',
                                        details: []
                                    }
                                },
                                {
                                    block: {
                                        top: '料金プランにおける利用定員数は、同時に受け入れることができる最大人数とし、行政・自治体に届出している利用定員数を適用いたします。',
                                        details: []
                                    }
                                },
                                {
                                    block: {
                                        top: '本導入申込完了後のキャンセルは、利用開始日の前々月の末日までとさせて頂き、利用開始日前月でのキャンセルは受付できませんのでご注意下さい。',
                                        details: []
                                    }
                                },
                                {
                                    block: {
                                        top: '解約を希望する場合は、1ヶ月以上前までにお知らせいただきますようお願いします。解約の申込が通知された日の翌月末日で解約となります。',
                                        details: []
                                    }
                                },
                                {
                                    block: {
                                        top: '月間プラン以外の場合、ご利用料金は「一括払い」にてご請求させていただきます。',
                                        details: []
                                    }
                                }
                            ],
                            about_tablet_request_first: [
                                {
                                    block: {
                                        top: 'タブレットレンタルについて、以下重要事項をご確認ください',
                                        details: [
                                            'タブレットレンタルサービス｢Rehab Cloud タブレット」の個別規約（以下「本個別規約」といいます。）に基づき、',
                                            'タブレットレンタルサービス（以下「本貸与サービス」といいます。）を行う提供条件について定めます。'
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '＜１．Rehab Cloudタブレットレンタルサービスに関して＞',
                                        details: [
                                            '(1) 本貸与サービスは株式会社Rehab for JAPAN（以下「当社」といいます。）によるRehab Cloudサービスに基づき提供いたします。',
                                            '本貸与サービスについては、当社が別途定める「Rehab Cloudタブレット利用規約」も併せてご確認下さい。',
                                            '(2) 貸与するタブレット端末（以下「本件タブレット端末」といいます。）は「LenovoTab7」または「LenovoTab6」となります。',
                                            '(3) 貸与品の内容は以下のとおりです。',
                                            '・LenovoTab7、LenovoTab6本体（USIMカード含む）',
                                            '・LenovoTab ACアダプタ'
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '＜２．サービス提供エリアに関して＞',
                                        details: [
                                            '(1) 本貸与サービスの提供区域は、キャリアであるソフトバンク株式会社(以下「ソフトバンク」といいます。)が定める通信区域とします。',
                                            '(2) 利用可能エリアはソフトバンクの5G、4G、並びに3Gの利用可能エリアに準じます。'
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '＜３．通信制限に関して＞',
                                        details: [
                                            '(1) 本件タブレット端末は、毎月50GBを上限として、高速データ通信を利用することができます。',
                                            '(2) 本件タブレット端末のデータ通信量が前項の上限を超過した場合、当該の超過日から月末日までの期間、通信速度を送受信時最大128kbpsに制限いたします。',
                                            '(3) 本件タブレット端末は、データ通信量を翌月以降に繰り越せないものとします。'
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '＜４．利用料金に関して＞',
                                        details: [
                                            '(1) 本貸与サービスの利用料金は利用料金表に定めるとおりです。なお、初期費用、利用料金及びその他費用は、当社が事前に通知または公表することにより変更されることがあります。'
                                        ]
                                    }
                                }
                            ],
                            about_tablet_request_second: [
                                {
                                    block: {
                                        top: '',
                                        details: [
                                            '(2) 利用料金表に定める本貸与サービスの利用料金およびその他費用を、本利用規約に規定するRehab Cloudサービスの利用料金に加えて、当社にお支払い下さい。' +
                                                '但し、Rehab Cloud Entry / Medium / Standard / Proプランを契約する事業所においては、1台目の利用料金及び初期費用についてはRehab Cloud Entry / Medium / Standard / Proプランの利用料金に含まれるものとします。',
                                            '(3) 初回事務手数料は、貸与品の引渡し完了にかかわらず、サービス利用開始日の属する月に発生します。',
                                            '(4) 月額基本料金はサービス利用開始日の属する月から発生し、サービス解約もしくは終了日の属する月まで発生します。',
                                            'なお、貸与品の到着がサービス利用開始日より遅れた場合であっても、それが当社の故意又は重過失による場合を除き、月額基本料金の日割は行わず1ヶ月分の料金が発生しますので、ご注意下さい。',
                                            '(5) 月途中でのご解約の場合であっても、月額基本料金の日割は行わず1ヶ月分の料金が発生しますので、ご注意下さい。',
                                            '(6) 本利用規約および本個別規約にて禁止された行為により、別途通信料金等が発生した場合、当該通信料金等を加えて利用料金をお支払い頂きますので、ご注意下さい。',
                                            '(7) 本貸与サービスの利用料金は、毀損または紛失その他の理由により本貸与サービスの利用ができない期間であっても同様に発生いたします。'
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '＜５．本人確認に関して＞',
                                        details: [
                                            '(1) タブレット端末の不正な利用を防止するため、お申し込みの際に、法人の場合は法人様確認とご担当者様の本人確認が必要となります（携帯音声通信事業者による契約者等の本人確認等および携帯音声通信役務の不正な利用防止に関する法律（平成17年法律第31号）第10条）。',
                                            '(2) 法人様確認に関しては、お申し込み頂いた内容を元に当社で法人の証明書を取得し確認させて頂きます。',
                                            '(3) ご担当者様又はご本人様の本人確認については、下記のうちいずれか1点の書類を電子データでご提出のうえ、氏名、住所、生年月日等の契約者を特定する情報を確認させて頂きます。',
                                            '　・運転免許証',
                                            '　・個人番号カード(マイナンバーカード)',
                                            '　・在留カード',
                                            '　・特別永住者証明書証',
                                            '　※原本提出は不要です。'
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '＜６．通信速度の制御・利用状況の確認について＞',
                                        details: [
                                            '(1) ソフトバンクがネットワーク品質を確保するために、通信の種類・内容、時間帯等の条件に応じて、又は、これらの条件にかかわらず、通信速度を制御する場合があります。',
                                            '(2) ソフトバンクが、ネットワーク品質を確保するため、および、本サービス契約に即した利用がなされているかを確認・調査するために、通信の種類、内容及びパケット量等の利用状況（本貸与サービスに即した利用がなされているかを確認・調査する目的を含みます）を確認する場合があります。 ',
                                            '(3) 前号の目的のため、当社が、ソフトバンクに対して、会員等の通信の種類、内容およびパケット量等の利用状況に関する情報を提供する場合があります。'
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '＜７．故障・紛失について＞',
                                        details: [
                                            '(1) 初期不良、破損、その他貸与品の不具合、盗難・紛失の場合、交換対応で代替機を貸与いたします。',
                                            '但し、事業所様又は個人のお客様に悪意・故意・過失が認められる場合は別途修理・交換費用をお支払い頂きます。',
                                            '(2) 盗難、紛失の場合の交換対応は、1台毎に6ヶ月に1回までとし、同期間内で2回目以降は別途未返却損害金をお支払い頂きます。当該交換対応に伴ってSIMカードの再発行が必要な場合は、SIMカード再発行手数料が発生します。'
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '＜８．キャンセル・解約について＞',
                                        details: [
                                            '(1) お申込手続完了後のキャンセルは、利用開始日の前々月の末日までとさせて頂き、利用開始日前月でのキャンセルは受付できませんのでご注意下さい。',
                                            '(2) 利用開始後に解約をご希望される場合は、当社が定める方法により解約申請を行うことにより、本貸与サービス契約を解約することができます。',
                                            '本貸与サービス契約は、当該申請がなされた日の属する月の翌月末日をもって終了します。なお、解約手数料および解約時の違約金はございません。',
                                            '(3) 月途中のご解約の場合であっても、月額基本料金の日割は行わず1ヶ月分の料金が発生しますので、ご注意下さい。',
                                            '(4) Rehab Cloudサービスに係る契約を解約した場合、本貸与サービスの利用は、Rehab Cloudサービスに係る契約の終了日をもって終了します。',
                                            'この場合、当社は既に受領した利用料金その他の料金の払い戻しは一切行いません。',
                                            ''
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '＜９．返却＞',
                                        details: [
                                            '(1) 以下の各号に該当する場合、当社指定の返却フォームから申込のうえ、各号に定める期限までに、貸与品を当社が指定する場所にご返却ください。なお、送料は、お客様のご負担とします。',
                                            '　①理由の如何にかかわらず、本貸与サービス契約が終了する場合：契約終了日もしくは本貸与サービス終了日から2週間以内',
                                            '　②当社にて貸与品に何らかの瑕疵があると認められ、代替機が発送された場合（紛失等の場合を除く）：代替機が会員等に到着した日から2週間以内',
                                            '　③貸与品の毀損により代替機の申込をした場合：本利用規約の定めにより、代替機が会員等に到着した日から2週間以内',
                                            '　④貸与品の紛失等が生じた貸与品が発見された場合：貸与品が発見された日から2週間以内',
                                            '　⑤機種変更の申込をした場合：新しい貸与品の到着した日から2週間以内',
                                            '(2)　③の場合、返却された貸与品に当社が通常の損耗を超える損傷等があると判断したときは、その通常の損耗を超える部分の損傷等を補修するための費用として当社が指定する修理代を請求いたします。',
                                            '(3)　④の場合、紛失等が生じた貸与品が発見されたときは、警察等当該貸与品を占有する第三者から当該貸与品の引渡しを受け、発見された貸与品を当社が指定する場所にご返却下さい。',
                                            'なお、紛失等が生じた貸与品が発見された場合または当社にご返却頂いた場合であっても、利用料金表に定める各種手数料が発生しますので、ご注意下さい。',
                                            '(4)　⑤の場合、または当社に対して返却した機種変更前の貸与品についてお客様が故意もしくは重過失により毀損させたと当社が判断する場合、利用料金表に定める損害金が発生します。',
                                            'なお、新しい貸与品の引渡しが当社が予め通知した納品予定日より遅延した場合であっても、それがお客様の帰責事由による場合は、当社は何ら責任を負いません。',
                                            '(5)　本条に定める貸与品の返却に際し、定められた期間内に貸与品を返却しなかった場合、利用料金表に定める各種損害金が発生しますので、ご注意下さい。',
                                            '(6)　貸与品の返却に際し、内部情報の消去、外部記録媒体の取り外し、本件タブレット端末の初期化、およびアクティべーションロックの解除をしたうえでご返却下さい。',
                                            'なお、当該初期化等は、貸与品が未開封または未使用の場合も行うものとします。'
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '＜１０．お問い合わせ＞',
                                        details: [
                                            '故障修理のお申し込みや料金に関する問い合わせ等は、Rehab Cloudカスタマーサポート窓口へお問い合わせ下さい。',
                                            'なお、お問い合わせ内容によっては、Rehab Cloudカスタマーサポート窓口のみでご回答できない場合があり、その場合、お客様ご自身で各対応窓口におかけ直しいただく場合がございますので、あらかじめご了承下さい。'
                                        ]
                                    }
                                }
                            ],
                            about_input_service: [
                                {
                                    block: {
                                        top: '入力代行は初期設定時（導入申込〜リハプラン利用開始）のみ行うサービスとなります。',
                                        details: []
                                    }
                                },
                                {
                                    block: {
                                        top: '入力代行は、利用開始日以降にお客様自身が利用者基本情報をリハプランに登録する業務を弊社が代替するサービスとなっております。',
                                        details: [
                                            'そのため、利用開始日時点で全ての利用者基本情報が登録されていることを保証するサービスではないことをご了承ください。'
                                        ]
                                    }
                                },
                                {
                                    block: {
                                        top: '実際の入力代行人数が本導入申込にて申請いただいた人数を下回る場合においても、申請人数×1,000円のサービス料金が発生します。',
                                        details: [
                                            'ただし、半年プラン・年間プランを申込まれた場合、料金は無料となります'
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    button_caption: {
                        back_to_apply_info: '申込情報の入力へ戻る',
                        to_confirm: '入力内容の確認へ',
                        back_to_office: '事業所情報の入力へ戻る',
                        to_apply_info: '申込情報の入力へ',
                        to_request_info: '請求情報の入力へ',
                        to_shipping_address_info: '配送先情報入力へ',
                        to_consent: '重要事項の確認へ',
                        back_to_request_info: '請求情報の入力へ戻る',
                        back_to_shipping_address_info: '配送先情報の入力へ戻る',
                        next: '次へ',
                        back: '戻る',
                        request: '上記に同意して申込む',
                        fix_button: '入力内容の修正'
                    },
                    steps: {
                        office_info: '事業所情報',
                        apply_info: '申込情報',
                        request_info: '請求情報',
                        shipping_address_info: '配送先情報',
                        impotant_info: '重要事項の確認',
                        confirm: '入力内容の確認',
                        complete: '入力完了',
                        consent: '重要事項の確認',
                        contract: '契約情報'
                    },
                    data_labels: {
                        apply_info: {
                            period: [
                                { label: '月額プラン（月々払い）', value: '月額プラン（月々払い）', system_value: 'month', sales_force_value: '月額' },
                                { label: '半年プラン（一括払い）', value: '半年プラン（一括払い）', system_value: 'six', sales_force_value: '半年' },
                                { label: '年間プラン（一括払い）', value: '年間プラン（一括払い）', system_value: 'year', sales_force_value: '年間' }
                            ],
                            apply_capacity: [
                                { label: '1〜10名', value: '1〜10名', system_value: 'one' },
                                { label: '11〜20名', value: '11〜20名', system_value: 'eleven' },
                                { label: '21〜35名', value: '21〜35名', system_value: 'twenty_one' },
                                { label: '36名以上', value: '36名以上', system_value: 'thirty_six' }
                            ],
                            apply_capacity_rehab_cloud: [
                                { label: '1〜10名', value: '1〜10名', system_value: 'one' },
                                { label: '11名以上', value: '11名以上', system_value: 'eleven' }
                            ]
                        },
                        request_info: {
                            how_to_request: [
                                { label: '口座振替（マネーフォワード ケッサイ）', value: '口座振替（マネーフォワード ケッサイ）', sales_force_value: 'マネーフォワードケッサイ（口座振替）' },
                                { label: '銀行振込（マネーフォワード ケッサイ）', value: '銀行振込（マネーフォワード ケッサイ）', sales_force_value: 'マネーフォワードケッサイ（銀行振込）' }
                            ],
                            how_to_send: [
                                { label: 'メール', value: 'メール' },
                                { label: '郵送', value: '郵送' }
                            ]
                        }
                    },
                    label: {
                        office_info: {
                            office_no: '介護保険事業所番号',
                            company_name: '法人名',
                            company_name_kana: 'フリガナ（法人名）',
                            office_name: '事業所名',
                            office_name_kana: 'フリガナ（事業所名）',
                            address: '住所',
                            zip: '郵便番号',
                            zip_2: '',
                            address_1: '都道府県',
                            address_2: '市区町村',
                            address_3: '番地以降',
                            company_no: '法人番号',
                            corporate_name: '法人名',
                            corporate_address: '法人住所',
                            corporate_zip: '郵便番号',
                            corporate_zip_2: '',
                            corporate_address_1: '都道府県',
                            corporate_address_2: '市区町村',
                            corporate_address_3: '番地以降',
                            tel: '電話番号',
                            capacity: '定員数',
                            capacity_append: '人',
                            request_email: 'メールアドレス（申込者）',
                            request_person: '申込者氏名',
                            request_person_last_name: '姓',
                            request_person_first_name: '名',
                            request_person_kana: 'フリガナ（申込者氏名）',
                            request_person_kana_last_name: 'セイ',
                            request_person_kana_first_name: 'メイ',
                            tantosya: 'アカウント管理者名（事業所の管理者名など）',
                            tantosya_last_name: '姓',
                            tantosya_first_name: '名',
                            tantosya_kana: 'フリガナ（アカウント管理者）',
                            tantosya_kana_last_name: 'セイ',
                            tantosya_kana_first_name: 'メイ',
                            tantosya_mail: 'メールアドレス（ログイン用アドレス）'
                        },
                        apply_info: {
                            apply_date: '申込日',
                            kino_kunren: 'リハプラン 機能訓練',
                            oral_care: 'リハプラン 口腔機能',
                            entry: 'Rehab Cloud Entry',
                            basic: 'Rehab Cloud Basic',
                            medium: 'Rehab Cloud Medium',
                            standard: 'Rehab Cloud Standard',
                            old_standard: 'Rehab Cloud Standard(2024年4月よりMedium)',
                            professional: 'Rehab Cloud Pro',
                            upgrade: 'Rehab Cloud アップグレード',
                            motion_ai: 'Rehab Cloud モーションAI',
                            upgrade_to_standard: 'Rehab Cloud Standardへのアップグレード',
                            additional_tablet: 'Rehab Cloud タブレット',
                            initial_service: '入力代行サービス',
                            start_date: '利用開始月',
                            price: '販売価格（税抜）',
                            initial_fee: '初回手数料（税抜）',
                            tablet: 'タブレット台数',
                            plan_period: 'プラン適用期間',
                            period: '申込プラン',
                            upgrade_to_standard_plan: 'アップグレード対象のご契約プラン',
                            current_plan: 'アップグレード対象のご契約プラン',
                            upgrade_plan: 'アップグレード後のご契約プラン',
                            apply_capacity: '一回あたりの受け入れ定員数',
                            input_number: '入力代行人数',
                            input_number_suffix: '人',
                            tablet_numbers: '台数',
                            previousPlan: '現契約プラン',
                            contractPlan: '申込プラン'
                        },
                        request_info: {
                            company_name: '請求先法人名',
                            office_name: '請求先事業所名',
                            tel: '請求先電話番号',
                            address: '請求先住所',
                            zip: '郵便番号',
                            zip_2: '',
                            address_1: '都道府県',
                            address_2: '市区町村',
                            address_3: '番地以降',
                            request_person: '請求先担当者名',
                            request_person_last_name: '姓',
                            request_person_first_name: '名',
                            request_email: '請求先担当者メールアドレス',
                            how_to_request: '支払い方法',
                            mfkessai_caption: '*当サービスではマネーフォワードケッサイを利用して、請求書の発行や代金の回収、管理を行っております。',
                            mfkessai_link_caption: '詳細に関してはこちらの資料をご確認ください。',
                            mfkessai_link: '・マネーフォワードケッサイご案内資料',
                            how_to_send: '請求書受取方法',
                            mail: '郵送',
                            account_transfer: '口座振替（マネーフォワード ケッサイ）',
                            same_to_office_info: '事業所情報と同じ場合はチェックして下さい'
                        },
                        shipping_address_info: {
                            company_name: '配送先法人名',
                            office_name: '配送先事業所名',
                            tel: '配送先電話番号',
                            address: '配送先住所',
                            zip: '郵便番号',
                            zip_2: '',
                            address_1: '都道府県',
                            address_2: '市区町村',
                            address_3: '番地以降',
                            request_person: '配送先担当者名',
                            request_person_last_name: '姓',
                            request_person_first_name: '名',
                            same_to_office_info: '事業所情報と同じ場合はチェックして下さい'
                        },
                        consent: {
                            about_request: '重要事項',
                            about_tablet_price_list: '【利用料金表】',
                            about_input_service: '入力代行について',
                            consent_check: '同意しました'
                        },
                        contract: {
                            price: '請求金額（税抜）',
                            tablet: 'タブレット台数',
                            request_start_date: '初回請求月',
                            tokubetu_detail: '備考'
                        },
                        fixed_text: {
                            additional_tablet_plan_name: '月間プラン（月々払い）'
                        }
                    },
                    placeholder: {
                        office_info: {
                            office_no: '例） 0000000000',
                            company_name: '例） 株式会社 Rehab for JAPAN',
                            company_name_kana: '例） カブシキガイシャリハブフォージャパン',
                            office_name: '例） リハブデイサービス',
                            office_name_kana: '例） リハブデイサービス',
                            address: '',
                            zip_1: '例） 141',
                            zip_2: '0031',
                            address_1: '例） 東京都',
                            address_2: '例） 品川区西五反田',
                            address_3: '例） 8丁目8-15カーニープレイス五反田8階',
                            company_no: '例） 0000000000',
                            corporate_name: '例） 株式会社 Rehab for JAPAN',
                            corporate_zip_1: '例） 141',
                            corporate_zip_2: '0031',
                            corporate_address_1: '例） 東京都',
                            corporate_address_2: '例） 品川区西五反田',
                            corporate_address_3: '例） 8丁目8-15カーニープレイス五反田8階',
                            tel: '例） 0367127770',
                            capacity: '',
                            request_person: '',
                            request_person_last_name: '例） 李羽生',
                            request_person_first_name: '例） 太郎',
                            request_person_kana: '',
                            request_person_kana_last_name: '例） リハブ',
                            request_person_kana_first_name: '例） タロウ',
                            tantosya: '',
                            tantosya_last_name: '例） 李羽生',
                            tantosya_first_name: '例） 花子',
                            tantosya_kana: '',
                            tantosya_kana_last_name: '例） リハブ',
                            tantosya_kana_first_name: '例） ハナコ',
                            tantosya_mail: '例） mail@example.com'
                        },
                        apply_info: {
                            apply_date: '',
                            kino_kunren: '',
                            oral_care: '',
                            initial_service: '',
                            start_date: '',
                            period: '',
                            apply_capacity: '',
                            input_number: '',
                        },
                        request_info: {
                            company_name: '例） 株式会社 Rehab for JAPAN',
                            office_name: '例） リハブデイサービス',
                            address: '',
                            zip_1: '例） 141',
                            zip_2: '0031',
                            address_1: '例） 東京都',
                            address_2: '例） 品川区西五反田',
                            address_3: '例） 8丁目8-15カーニープレイス五反田8階',
                            tel: '例） 0367127770',
                            request_person: '',
                            request_person_last_name: '例） 李羽生',
                            request_person_first_name: '例） 太郎',
                            request_email: 'mail@example.com',
                            how_to_request: '',
                            how_to_send: '',
                        }
                    },
                    hint: {
                        office_info: {
                            office_no: '＊事業所未開設の方は入力不要です',
                            company_name: '',
                            company_name_kana: '',
                            office_name: '',
                            office_name_kana: '',
                            address: '',
                            zip_1: '',
                            zip_2: '',
                            address_1: '',
                            address_2: '',
                            address_3: '',
                            corporate_name: '',
                            company_no: [
                                '貴法人の法人番号をご入力下さい。',
                                'タブレット貸与時の法人確認に必要となります。'
                            ],
                            corporate_zip_1: '',
                            corporate_zip_2: '',
                            corporate_address_1: '',
                            corporate_address_2: '',
                            corporate_address_3: '',
                            tel: '＊事業所の電話番号を入力してください',
                            capacity: '',
                            request_person: '',
                            request_person_last_name: '',
                            request_person_first_name: '',
                            request_person_kana: '',
                            request_person_kana_last_name: '',
                            request_person_kana_first_name: '',
                            tantosya: '＊こちらの情報でリハプランの初期アカウントが発行されます。',
                            tantosya_last_name: '',
                            tantosya_first_name: '',
                            tantosya_kana: '＊こちらの情報でリハプランの初期アカウントが発行されます。',
                            tantosya_kana_last_name: '',
                            tantosya_kana_first_name: '',
                            tantosya_mail: '＊リハプランのログインに使用するメールアドレスをご入力ください。'
                        },
                        apply_info: {
                            apply_date: '',
                            kino_kunren: '',
                            oral_care: '',
                            initial_service: '',
                            start_date: '',
                            period: '',
                            apply_capacity: '＊1日に複数回サービスを提供している場合、1度に受け入れる定員数をご記入ください。',
                            input_number: '',
                        },
                        request_info: {
                            company_name: '',
                            office_name: '',
                            address: '',
                            zip_1: '',
                            zip_2: '',
                            address_1: '',
                            address_2: '',
                            address_3: '',
                            tel: '',
                            request_person: '',
                            request_person_last_name: '',
                            request_person_first_name: '',
                            request_email: '',
                            how_to_request: '',
                            how_to_send: '＊口座振替通知書はメールのみの通知となります'
                        },
                        consent: {
                            consent_check: '上記の内容を確認し、「同意しました」にチェックを入れてください。',
                        }
                    }
                },
                check_email: {
                    title: '確認メールの送信',
                    messages: {
                        how_to_confirm: [
                            '申込者のメールアドレスを入力して、上記に同意して確認メールを送信するボタンをクリックしてください。',
                            '入力したメールアドレス宛に登録手続きのURLが届きます。',
                            'メール受信制限をされている方は、 noreply@rehaplan.jp からのメール受信を許可してください。',
                        ]
                    },
                    label: {
                        email: 'メールアドレス'
                    },
                    placeholder: {
                        email: 'mail@example.com'
                    },
                    button_caption: {
                        send_email: '上記に同意して確認メールを送信する'
                    }
                },
                confirm_identification: {
                    top_title: 'ご本人様／法人様ご確認フォーム',
                    top_company_only: '法人様ご確認フォーム',
                    identification_title: 'ご本人様確認入力項目',
                    company_idetification_title: '法人様確認入力項目',
                    messages: {
                        message_to_idetification: [
                            'この度は、Rehab Cloudのお申込み誠にありがとうございます。',
                            '貴法人へのタブレット貸与のため、申込者様のお名前とご本人様確認書類のアップロード並びにセルフィーが必要となります。',
                            '下記フォームの内容にお間違えないかご確認頂き、',
                            '「公的身分証の確認／セルフィーを実施する」ボタンにてご本人様確認書類のアップロード並びにセルフィーをお願い致します。'
                        ],
                        message_to_corporate_idetification: [
                            'この度は、Rehab Cloudのお申込み誠にありがとうございます。',
                            '貴法人へのタブレット貸与のため、法人番号、法人名、法人住所のご登録が必要となります。',
                            '公的身分証の確認及び、セルフィーを実施頂いた後、',
                            '下記フォームの内容にお間違いがないかご確認頂き、「ご本人様／法人様確認を完了する」ボタンを押下下さい。'
                        ],
                        message_to_corporate_only_identification: [
                            'この度は、Rehab Cloudのお申込み誠にありがとうございます。',
                            '貴法人へのタブレット貸与のため、法人番号、法人名、法人住所のご登録が必要となります。',
                            '下記フォームの内容にご入力頂き、「法人様確認を完了する」ボタンを押下下さい。'
                        ],
                        other_company_identification_form: {
                            label: "同一法人の他事業所の申請状況\n",
                            message: "他事業所の申請が否認された際には\n",
                            message2: "申請いただいた内容で法人確認が実施されます。",
                        }
                    },
                    subimit_company_button_caption: {
                        submit_comparing_data: 'ご本人様／法人様確認を完了する',
                        submit_only_comparing_data: '法人様確認を完了する'
                    },
                    subimit_person_button_caption: {
                        submit_comparing_data: '公的身分証の確認／セルフィーを実施する'
                    },
                    identification_warning_message: {
                        first_message: '※通信環境の良い場所で撮影をして下さい。',
                        second_message: '※ブラウザのカメラ設定を許可して下さい。',
                        third_message: '※明るい場所で撮影してください。',
                        forth_message: '※テキストが読み取れるように撮影して下さい'
                    },
                    identification_error_message: {
                        default_message: 'URLが期限切れです。営業担当にご確認ください。',
                        already_submit_message: 'すでに他事業所様で法人確認が提出されています。営業担当にご確認ください。',
                        approved_message: 'すでに他事業所様で法人確認が承認されました。営業担当にご確認ください。'
                    }
                }
            },
            sales_force: {
                reflect: {
                    titles: {
                        pre: '申込予定の内容の事前登録',
                        after: 'SalesForceへの申込内容登録',
                    },
                    msg: {
                        change_status_mirenkei: 'SalesForce登録状況を「登録前」に変更しますか？',
                        change_status_renkeizumi: 'SalesForce登録状況を「登録済」に変更しますか？',
                        re_correct_error: '再提出URLの発行に失敗しました。。開発に連絡してください。。',
                        confirm_re_correct: '再提出URLを発行しますか？<br>＊入力内容に不備がある場合のみ、「OK」ボタンをクリックしてください。',
                        confirm_after_re_correct: '7日間有効な再提出URLを発行しました。<br>入力画面を別タブで確認しますか？',
                        tokubetu_taio: '特別対応は個別機能訓練・口腔機能・入力代行で同じ内容が登録されます。',
                        alert_torihikisaki_id: '取引先IDが未入力の状態で、登録することができません。先に取引先を登録してください。',
                        alert_torihikisaki_sekininsya_id: '取引先責任者（申込者）IDは必須の項目です。先に取引先責任者（申込者）を登録してください。',
                        alert_opportunity_id: '商談IDは必須の項目です。メール内容を登録する商談オブジェクトのIDを入力してください。',
                        alert_pricebook_id: '価格表が選択されていません。価格表を選択してください。',
                        alert_free_pricebook_id: '無料期間有りにチェックが付いていますが、【無料期間】価格表が選択されていません。【無料期間】価格表を選択してください。',
                        alert_product_id: '商品が選択されていません。商品を選択してください。',
                        alert_free_product_id: '無料期間有りにチェックが付いていますが、【無料期間】商品が選択されていません。【無料期間】商品を選択してください。',
                        alert_free_product_period: '無料期間有りにチェックが付いていますが、【無料期間】期間が選択されていません。【無料期間】期間を選択してください。',
                        alert_price: '価格が入力されていません。価格を入力してください。',
                        arert_start_date: '利用開始月が入力されていません。利用開始月を入力してください。',
                        alert_select_capacity: '定員数が選択されていません。定員数を選択してください。',
                        alert_select_upgrade_to: 'アップグレード先が選択されていません。アップグレード先を選択してください。',
                        alert_empty_tablet_number: 'タブレット台数が未入力です。タブレット台数を入力してください。',
                        alert_invalid_tablet_number: 'タブレット台数は1台以上でなければなりません。正しいタブレット台数を入力してください。',
                        alert_invalid_tablet_calculation: 'Rehab Cloud タブレット初回手数料／Rehab Cloud タブレットの計算でエラーが発生しています。開発にご連絡下さい。',
                        alert_not_link_opportunity_for_input: '商談Objectが、salesForceに登録されていません。先に、「商談/商談商品（機能訓練）」「商談/商談商品（口腔機能）」の登録を完了させてください。',
                        price_warning: '標準の価格と異なります。入力内容が正しいか確認してください。',
                        price_error: '標準の価格と違う価格が入力されていますが、特別対応に記載がありません。特別対応の内容を入力してください。',
                        input_price_error: '単価（税抜）を選択してください。',
                        bunkatu_error: '分割の有無にチェックが入っていますが、特別対応に記載がありません。特別対応の内容を入力してください。',
                        tokubetu_error: '「Standard Price Book 以外の価格表を選択している」または、「無料期間の登録が行なわれている」が、特別対応の記載がありません。特別対応詳細を入力してください。',
                        tokubetu_error_second: '特別対応の詳細への入力は必須です。特別対応の詳細を入力して下さい。',
                        no_service_error: '個別機能訓練・口腔機能が申込まれていないため、入力代行を連携することができません。',
                        not_lincage_kobetu_error: '個別機能訓練の商談オブジェクトが連携されていません。先に「商談/商談商品（機能訓練）」を連携してください。',
                        not_lincage_oral_care_error: '口腔機能の商談オブジェクトが連携されていません。先に「商談/商談商品（口腔機能）」を連携してください。',
                        use_kobetu_opportunity_message: '個別機能訓練の商談オブジェクトに連携を行います。特別対応などがある場合は、「商談/商談商品（機能訓練）」にて内容を入力してください。',
                        use_oral_care_opportunity_message: '口腔機能の商談オブジェクトに連携を行います。特別対応などがある場合は、「商談/商談商品（口腔機能）」にて内容を入力してください。',
                        use_kobetu_price_book_message: '個別機能訓練と同じ価格表しか選択できません。変更が必要な場合は、「商談/商談商品（機能訓練）」にて価格表を変更してください。',
                        use_oral_care_price_book_message: '個別機能訓練と同じ価格表しか選択できません。変更が必要な場合は、「商談/商談商品（機能訓練）」にて価格表を変更してください。',
                        select_one_year_item: '※年間商品を選択した場合、必ずIT補助金利用はチェックされます。',
                        select_month_item: '※月額商品を選択した場合、IT補助金利用は選択できません。',
                        select_two_years_item: '※2年商品を選択した場合、必ずIT補助金利用はチェックされます。',
                        after_selected_price_list_msg_for_date_picker: '価格表を選択後に日付が選択できます',
                        after_selected_price_list_msg_for_select_box: '価格表を選択後にアップグレード先が選択できます',
                        after_selected_price_list_msg_for_select_capacity: '価格表を選択後に定員数が選択できます'
                    },
                    button_caption: {
                        sales_force: 'salesforceに登録する',
                        save_opportunity: '申込予定の商品を保存',
                        load_sales_force: 'salesforceの情報を読み込む',
                        upgrade_sales_force_plan: 'salesforceの情報を読み込む（Upgrade to Standard）',
                        create_new_plan: '別の申込予定を登録',
                        re_correct: '再提出URLを発行する',
                        csv_output: 'CSVを出力する',
                        move_sales_force: 'SalesForceで確認する',
                        add_opportunity: '無料期間あり（効果実感キャンペーンなどの無料期間つきキャンペーン）'
                    },
                    placeholder: {
                        torihikisaki: {
                            id: '0012j00000XXXXXXXX'
                        },
                        torihikisaki_sekininsya: {
                            id: '0012j00000XXXXXXXX',
                            torihikisaki_id: '0012j00000XXXXXXXX'
                        },
                        contract: {
                            torihikisaki_id: '0012j00000XXXXXXXX',
                            contract_id: '0012j00000XXXXXXXX',
                            opportunity_id: '商談ID'
                        },
                        opportunity: {
                            torihikisaki_id: '0012j00000XXXXXXXX',
                            torihikisaki_sekininsya_id: '0012j00000XXXXXXXX',
                            opportunity_id: '0012j00000XXXXXXXX',
                            opportunity_line_item_id: '0012j00000XXXXXXXX',
                            opportunity_name: '',
                            email_subject: '',
                            email_content: ''
                        },
                        application_details: {
                            torihikisaki_id: '0012j00000XXXXXXXX',
                            torihikisaki_sekininsya_id: '0012j00000XXXXXXXX',
                            application_detail_id: '0012j00000XXXXXXXX',
                            email_subject: '',
                            email_content: ''
                        }
                    },
                    hint: {
                        torihikisaki: {
                            id: '＊更新の場合は、取引先IDを入力してください。',
                            pre_id: '＊取引先IDは必須の項目です。'
                        },
                        torihikisaki_sekininsya: {
                            id: '＊更新の場合は、取引先責任者IDを入力してください。',
                            pre_id: '＊取引先責任者IDは必須の項目です。',
                            torihikisaki_id: '＊取引先IDは必須の項目です。',
                        },
                        contract: {
                            contract_id: '＊更新の場合は入力してください',
                            torihikisaki_id: '＊取引先IDは必須の項目です。',
                            price_input: '＊入力代行の単価を選択してください。',
                            price_input_base: '＊標準価格は変更できません。',
                            price_kobetu: '＊選択した価格表・商品に合わせて自動で設定されています。',
                            price_oral_care: '＊契約プラン（期間）に応じて初期値が設定されています。',
                            contract_state: '＊現在日付が、契約開始日よりも後の場合は、契約中が初期値に設定されています。',
                            request_start_date: '＊契約開始月の翌月の一日が初期値に設定されています。',
                            bunkatsu: '',
                            it_period: '＊年間プランやIT導入補助金利用にチェックが入っている場合、必須の項目です。',
                            contract_edate: '＊開始日と、期間から計算した値が、初期値に設定されています。',
                            upgrade_contract_edate: '※既存の商談の契約終了日が設定されます',
                            tokubetu_detail: '【注意】入力した内容は、【契約内容確定メール】の備考として、お客様にそのまま転送されます。',
                            apply_start_date: '＊無料期間を利用しない場合、「利用開始日」と等しくなります。',
                            upgrade_to_standard_apply_start_date: '基本的に「利用開始日」と等しくなります。アップグレード対象の商談の契約終了日以降の月は選択できません。'
                        },
                        opportunity: {
                            torihikisaki_id: '＊取引先IDは必須の項目です。',
                            torihikisaki_sekininsya_id: '＊取引先責任者（申込者）は必須の項目です。',
                            opportunity_id: '＊商談IDを変更することはできません。',
                            pre_id: '＊商談IDは必須の項目です。',
                            opportunity_line_item_id: '＊更新の場合は入力してください。',
                            opportunity_name: '',
                            email_subject: '',
                            email_content: ''
                        },
                        application_details: {
                            torihikisaki_id: '＊取引先IDは必須の項目です。',
                            torihikisaki_sekininsya_id: '＊取引先責任者（申込者）は必須の項目です。',
                            application_detail_id: '＊更新の場合は入力してください',
                            application_detail_after_id: '＊申込内容IDは編集できません',
                            email_subject: '',
                            email_content: '',
                            email_auto_send_pre: '＊特別対応がない場合は自動でチェックが付きます。'
                        }
                    },
                    data_labels: {
                        contract: {
                            contract_state: [
                                { label: '契約前', value: '契約前' },
                                { label: '契約中', value: '契約中' }
                            ],
                            before_contract: '契約前',
                            after_contract: '契約中',
                            bunkatsu: { label: ' ', value: 'true' },
                            it_flg: { label: ' ', value: 'true' },
                            cancel_flg: { label: ' ', value: 'true' },
                            tokubetu_flg: { label: ' ', value: 'true' },
                            it_period: [
                                { text: '選択', value: '' },
                                { text: '1年', value: '1年' },
                                { text: '2年', value: '2年' },
                                { text: '3年', value: '3年' },
                                { text: '4年', value: '4年' },
                                { text: '5年', value: '5年' },
                                { text: '6年', value: '6年' }
                            ]
                        },
                        opportunity: {
                            free_period: [
                                { text: '選択', value: '' },
                                { text: '1ヶ月', value: '1' },
                                { text: '2ヶ月', value: '2' },
                                { text: '3ヶ月', value: '3' },
                                { text: '4ヶ月', value: '4' },
                                { text: '5ヶ月', value: '5' },
                                { text: '6ヶ月', value: '6' },
                                { text: '7ヶ月', value: '7' },
                                { text: '8ヶ月', value: '8' },
                                { text: '9ヶ月', value: '9' },
                                { text: '10ヶ月', value: '10' },
                                { text: '11ヶ月', value: '11' },
                                { text: '12ヶ月', value: '12' }
                            ],
                            email_subject: '【Rehab Cloud】契約内容確定のご連絡',
                        },
                        application_details: {
                            email_subject_pre: '【Rehab Cloud】（%{office_name}）導入申込手続きのご案内',
                            email_auto_send_pre: { label: ' ', value: 'true' },
                        }
                    },
                    label: {
                        price_book: {
                            price_book_select: '価格表',
                            price_book_select_free: '【無料期間】価格表'
                        },
                        status: {
                            mirenkei: '登録前',
                            renkeizumi: '登録済み'
                        },
                        tabs: {
                            torihikisaki: '取引先',
                            torihikisaki_sekininsya_apply: '取引先責任者（申込者）',
                            torihikisaki_sekininsya_tanto: '取引先責任者（リハプランアカウント）',
                            contract_kobetu: '契約（機能訓練）',
                            opportunity_kobetu: '商談/商談商品（機能訓練）',
                            contract_oral_care: '契約（口腔）',
                            opportunity_oral_care: '商談/商談商品（口腔）',
                            contract_input_agency: '契約（入力代行）',
                            opportunity_input_agency: '商談商品（入力代行）',
                            opportunity: '商談',
                            application_details: '申込内容',
                            opportunity_entry: 'Entry',
                            opportunity_basic: 'Basic',
                            opportunity_old_standard: 'Standard（旧）',
                            opportunity_medium: 'Medium',
                            opportunity_standard: 'Standard',
                            opportunity_professional: 'Pro',
                            opportunity_motion_ai: 'モーションAI',
                            opportunity_upgrade_standard: 'アップグレード',
                            opportunity_upgrade: 'アップグレード',
                            opportunity_additional_tablet: 'タブレット単体申込み'
                        },
                        titles: {
                            common_area: '共通情報',
                            each_area: '商品ごと情報'
                        },
                        top: {
                            apply_date: '申込日',
                            apply_person: '申込者',
                            company_name: '会社名',
                            office_name: '事業所名',
                            reflect_status: 'SalesForce登録状況',
                            current_user: 'ログイン中ユーザーID',
                        },
                        torihikisaki: {
                            id: '取引先ID',
                            jig_no: '事業所番号',
                            company_name: '法人名',
                            company_name_kana: '法人名カナ',
                            office_name: '事業所名',
                            office_name_kana: '事業所名カナ',
                            address: '住所（事業所住所）',
                            tel: '事業所TEL',
                            email: '事業所アドレス',
                            request_company_name: '請求先法人名',
                            request_office_name: '請求先事業所名',
                            request_tel: '請求先電話番号',
                            request_address: '住所（請求先住所）',
                            request_person: '請求先担当者名',
                            request_mail: '請求先メールアドレス',
                            how_to_request: '請求方法',
                            how_to_send: '通知方法',
                            corporate_name: '法人名',
                            company_no: '法人番号',
                            corporate_address: '法人住所'
                        },
                        torihikisaki_sekininsya: {
                            id: '取引先責任者ID',
                            pre_id: '取引先責任者(申込者)ID',
                            torihikisaki_id: '取引先ID',
                            sei: '姓',
                            mei: '名',
                            name_kana: '氏名カナ',
                            mail: 'メール'
                        },
                        contract: {
                            tokubetu_taio_top: '特別対応',
                            contract_id: '契約ID',
                            torihikisaki_id: '取引先ID',
                            contract_edate: '契約終了日',
                            tablets: '台',
                            price: '販売価格（税抜）',
                            tablet: 'タブレット台数',
                            price_input: '単価（税抜）',
                            contract_state: '契約状況',
                            request_start_date: '請求開始日',
                            contract_period: '利用年数',
                            bunkatsu: '分割の有無',
                            it_flg: 'IT導入補助金利用',
                            it_period: '利用年数',
                            tokubetu_flg: '特別対応フラグ',
                            tokubetu_detail: '特別対応の詳細',
                            yen: '円',
                            kobetu: '機能訓練',
                            oral_care: '口腔機能',
                            input_agency: '入力代行',
                            entry: 'Rehab Cloud Entry',
                            basic: 'Rehab Cloud Basic',
                            standard: 'Rehab Cloud Standard',
                            old_standard: 'Rehab Cloud Standard(2024年4月よりMedium)',
                            medium: 'Rehab Cloud Medium',
                            professional: 'Rehab Cloud Pro',
                            upgrade: 'Rehab Cloud アップグレード',
                            motion_ai: 'Rehab Cloud モーションAI',
                            upgrade_to_standard: 'Rehab Cloud アップグレード',
                            additional_tablet: 'Rehab Cloud タブレット',
                            additional_tablet_initial_fee: 'Rehab Cloud タブレット初回手数料',
                            apply_date: '申込日',
                            apply_shipping_address: '配送先',
                            apply_seihin: '契約プラン（製品）',
                            apply_period: '契約プラン（期間）',
                            apply_ninsu: '契約プラン（定員数）',
                            apply_start_date: '契約開始日',
                            upgrade_to_standard_apply_start_date: '契約開始日（開始日を基準として[商品／標準価格／販売価格／請求開始日]が変更されます）',
                            input_number: '代行人数'
                        },
                        opportunity: {
                            kobetu: '個別機能訓練加算',
                            oral_care: '口腔機能向上加算',
                            input_agency: '入力代行',
                            entry: 'Rehab Cloud Entry',
                            basic: 'Rehab Cloud Basic',
                            standard: 'Rehab Cloud Standard',
                            medium: 'Rehab Cloud Medium',
                            professional: 'Rehab Cloud Pro',
                            old_standard: 'Rehab Cloud Standard(2024年4月よりMedium)',
                            upgrade: 'Rehab Cloud アップグレード',
                            upgrade_to_standard: 'Rehab Cloud アップグレード',
                            motion_ai: 'Rehab Cloud モーションAI',
                            torihikisaki_id: '取引先ID',
                            torihikisaki_sekininsya_id: '取引先責任者（申込者）ID',
                            opportunity_id: '商談ID',
                            opportunity_line_item_id: '商談商品ID',
                            opportunity_name: '商談名',
                            email_subject: 'メール件名',
                            email_content: 'メール内容',
                            product: '商品',
                            product_free: '【無料期間】商品',
                            unit_price: '標準価格',
                            free_period: '【無料期間】期間',
                            free_start_date: '【無料期間】契約開始日',
                            free_opportunity_id: '【無料期間】商談ID',
                            free_opportunity_item_id: '【無料期間】商談商品ID',
                            free_opportunity_name: '【無料期間】商談名',
                            cancel_flg: '無料期間内キャンセル可能フラグ'
                        },
                        application_details: {
                            torihikisaki_id: '取引先ID',
                            torihikisaki_sekininsya_id: '取引先責任者（申込者）ID',
                            application_detail_id: '申込内容ID',
                            email_subject: '申込内容確定メール件名',
                            email_subject_pre: '申込URL 案内メール件名',
                            email_content: '申込内容確定メール本文',
                            email_content_pre: '申込URL 案内メール本文',
                            email_auto_send_pre: '申込URL 案内メール自動送信',
                            scheduled_application_content: '申込予定内容',
                        },
                        fixed_text: {
                            additional_tablet_plan_name: '月間プラン（月々払い）'
                        }
                    },
                }
            },
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./common/src/constrains/locale/texts.ts
// module id = WQ+C
// module chunks = 1